/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Position_EstimatedInputs */

const fr_help_position_estimated = /** @type {(inputs: Help_Position_EstimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimé`)
};

const en_help_position_estimated = /** @type {(inputs: Help_Position_EstimatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimated`)
};

/**
* | output |
* | --- |
* | "Estimated" |
*
* @param {Help_Position_EstimatedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_position_estimated = /** @type {((inputs?: Help_Position_EstimatedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Position_EstimatedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_position_estimated(inputs)
	return en_help_position_estimated(inputs)
});